<template>
    <div class="i-head" :style="{background:config.background, borderBottom:config.border}">
        <div class="logo">
            <img :src="config.logo" alt="logo">
        </div>
    </div>
</template>

<script>
    export default {
        props:["config"]
    }
</script>

<style scoped>
    .i-head{
        padding:10px;
        border-bottom:1px solid lightgrey;
    }

    .logo img{
        max-height:100%;
    }
    .logo{
        max-width:140px;
        height: 30px;
        
    }
</style>